import React, { useState } from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import InputComponent from '@/components/Input';
import TextAreaComponent from '@/components/TextArea';
import ButtonComponent from '@/components/Button';
import { ReactComponent as RefreshCwIcon } from '@/assets/images/icons/refresh-cw.svg';
import { ReactComponent as SaveIcon } from '@/assets/images/icons/save.svg';

import './index.scss';
import { useTranslation } from 'react-i18next';
import { QUICK_SEND_MAX_CHARACTERS } from '@/constants';

function SmsTemplateForm({ data, loading, onSubmit }) {
  const [formInstance] = Form.useForm();
  const [formInitValue] = useState({
    name: data.name,
    content: data.content,
  });
  const { t } = useTranslation();

  const handleOnResetForm = () => {
    formInstance.setFieldValue('content', null);
  };

  return (
    <div className="new-sms-template-form-container">
      <Form
        layout="vertical"
        onFinish={onSubmit}
        autoComplete="off"
        className="form"
        form={formInstance}
        initialValues={formInitValue}
      >
        <Form.Item
          label={t('sms_create_template.fields.name')}
          name="name"
          className="form-item"
          rules={[
            {
              required: true,
              message: t('sms_create_template.error_code.name.require'),
            },
          ]}
        >
          <InputComponent
            placeholder={t('sms_create_template.placeholder.name')}
          />
        </Form.Item>

        <Form.Item
          label={t('sms_create_template.message')}
          name="content"
          rules={[
            {
              required: true,
              message: t('sms_create_template.error_code.message.required'),
            },
            {
              max: QUICK_SEND_MAX_CHARACTERS,
              message: t(
                'sms_create_template.error_code.message.message_max_length',
                {
                  max: QUICK_SEND_MAX_CHARACTERS,
                },
              ),
            },
          ]}
        >
          <TextAreaComponent
            placeholder={t('sms_create_template.placeholder.message')}
            rows={5}
            showSmsCount
          />
        </Form.Item>

        <Form.Item>
          <div className="form-actions-item">
            <ButtonComponent
              type="default"
              icon={<RefreshCwIcon />}
              onClick={handleOnResetForm}
              disabled={loading}
            >
              {t('transactions_page_trans.reset')}
            </ButtonComponent>
            <ButtonComponent
              type="primary"
              htmlType="submit"
              icon={<SaveIcon />}
              loading={loading}
            >
              {t('sms_create_template.save')}
            </ButtonComponent>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}

SmsTemplateForm.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default SmsTemplateForm;
